<app-base-modal [footerTemplate]="footerTemplate">
  <div class="flex flex-col justify-center">
    <svg-icon src="exclusive-feature" preserveAspectRatio="none" [stretch]="true"></svg-icon>
    <div class="title">{{ buildTranslationKey(relativeTitleKey) | translate }}</div>
    <div class="description">{{ buildTranslationKey('description') | translate }}</div>
    <img alt="icon" class="m-0" [src]="icon">
  </div>
</app-base-modal>

<ng-template #footerTemplate>
  <app-new-button class="contact-us" [type]="'primary'" [size]="'medium'" [clickOnEnter]="true" (click)="contactUs()">
    {{ buildTranslationKey('contactUs') | translate }}
  </app-new-button>
</ng-template>
